import { CustomSelectProps } from "../../../entities/CustomSelect";
import Select from "react-select";
import { customStyles } from "../CustomStyles";

const CustomSelect = <T,>({
  options,
  selectedOption,
  onChange,
  formatOptionLabel,
  placeholder,
  id,
}: CustomSelectProps<T>) => {
  return (
    <Select
      placeholder={placeholder}
      options={options}
      onChange={(value) => onChange(value)}
      value={selectedOption}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      id={id}
    />
  );
};

export default CustomSelect;
